import React from "react";
import { FaCheckCircle, FaCloudUploadAlt, FaTrash } from "react-icons/fa";


function ToolFileUploadField({
  label,
  file,
  setFile,
  helperText = "",
  placeholder = "Choose File or Drag & Drop",
  accept,
}) {
  return (
    <div className="tool-field-stack">
      <div className="tool-field-header">
        <label className="tool-label">{label}</label>
        {file ? (
          <button
            type="button"
            className="tool-link-button"
            onClick={() => setFile(null)}
          >
            <FaTrash /> Clear
          </button>
        ) : null}
      </div>

      {helperText ? <p className="tool-helper-text">{helperText}</p> : null}

      <div className={`file-upload-wrapper ${file ? "has-file" : ""}`}>
        <input
          type="file"
          accept={accept}
          className="file-upload-input"
          onClick={(event) => {
            event.target.value = null;
          }}
          onChange={(event) => setFile(event.target.files?.[0] || null)}
        />
        <div className="file-upload-text">
          {file ? (
            <span className="file-selected-text">
              <FaCheckCircle /> {file.name}
            </span>
          ) : (
            <>
              <FaCloudUploadAlt /> <span>{placeholder}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}


export default ToolFileUploadField;
